import api from "@/app/api";
import { EditPage } from "@/app/components/EditPage";
import Private from "@/app/components/Private";
import { ApiContext } from "@/app/contexts/ApiContext";

export default function Page() {
  return (
    <ApiContext.Provider
      value={{
        listData: api.getUsers,
        getFieldOptions: api.getUserFieldOptions,
        getData: api.getUser,
        getFields: api.getUserFields,
        updateEntry: api.updateUser,
        createFieldOption: () =>
          new Promise((resolve) => resolve(undefined as any)),
      }}
    >
      <Private>
        <EditPage />
      </Private>
    </ApiContext.Provider>
  );
}
